import { render } from "./TransactionDetailPage.vue?vue&type=template&id=32f80662"
import script from "./TransactionDetailPage.vue?vue&type=script&lang=js"
export * from "./TransactionDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__